import { Component, HostListener, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AccountAuthService } from '../../shared/account-auth.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class Navbar implements OnInit {
  protected readonly auth = inject(AccountAuthService);
  private readonly router = inject(Router);
  readonly dashboards = this.auth.dashboards;
  isAccountMenuOpen = false;

  navItems = [
    { path: '/', label: 'Home' },
    { path: '/signup', label: 'Sign Up' },
    { path: '/about', label: 'About' },
  ];

  ngOnInit() {
    this.auth.refreshAccess().subscribe({
      error: () => {
        // Invalid JWT clears the local session and routes to login.
      },
    });
  }

  isAccountRouteActive() {
    return this.router.url.startsWith('/account');
  }

  openAccountDashboard() {
    const dashboards = this.dashboards();
    if (dashboards.length <= 1) {
      this.isAccountMenuOpen = false;
      this.router.navigateByUrl(this.auth.defaultDashboardPath());
      return;
    }

    this.isAccountMenuOpen = !this.isAccountMenuOpen;
  }

  closeAccountMenu() {
    this.isAccountMenuOpen = false;
  }

  @HostListener('document:pointerdown', ['$event'])
  onDocumentPointerDown(event: PointerEvent) {
    if (!this.isAccountMenuOpen) {
      return;
    }

    const target = event.target as HTMLElement | null;
    if (target?.closest('.account-menu')) {
      return;
    }

    this.closeAccountMenu();
  }
}
